import React from 'react';
import AppRouter from "../../routes";
import Footer from "../../components/Footer/Footer";
import axios from "axios";
import config from "../../config";

class BaseLayout extends React.Component<any, any> {
    componentDidMount() {
        axios.get(config.baseURL + 'global_configurations/background_image').then(result => {
            document.body.style.backgroundImage = `url(${result.data.url})`;
        });
    }

    render(){
        return (
            <div style={{minHeight: '100%', position: 'relative'}}>
                <div style={{ height: '100%', paddingBottom: '5%'}}>
                    <div className="container-fluid justify-content-center d-flex" >
                        <div className="card mt-5 col-md-12 col-lg-7" id={'main-card'} >
                            <AppRouter/>
                        </div>
                    </div>
                </div>
                <div className={'card'} style={{position:"fixed", left: 0, bottom:0, width: '100%', height: '5%'}}>
                    <div className="card-header">
                        <Footer/>
                    </div>
                </div>
            </div>
        )
    }
}
export default BaseLayout;
